export default {"src":"/_next/static/media/affinamento.ae4aca3e.svg","height":54,"width":53,"blurWidth":0,"blurHeight":0};